import actions from './actions'

// role actions
import { modules } from '../../constants/QBActionsConst'

const defaultRole = {
    role_id: 0,
    action_ids: [],
    role_name: '',
}

const initState = {
    roles: [],
    qbactions: modules,
    currentRole: {},

    total: 0,
    pageSize: 8,
    pageIndex: 1,

    modalRoleInfoState: false,
    modalConfirmDeleteRole: false,
    currentroleOfUser: [],
}

const _handleUpdateAction = (state, actionId, status) => {
    try {
        let action_ids = state.currentRole.action_ids
        let ans = []

        if (status === true) {
            if (action_ids.includes(actionId)) return state

            ans = [...action_ids, ...[actionId]]
        } else {
            if (!action_ids.includes(actionId)) return state

            for (let index = 0; index < action_ids.length; index++)
                if (action_ids[index] !== actionId) ans.push(action_ids[index])
        }

        return {
            ...state,
            ...{
                currentRole: {
                    ...state.currentRole,
                    ...{
                        action_ids: ans,
                    },
                },
            },
        }
    } catch (ex) {
        return state
    }
}

const _handleUpdateAllAction = (state, status) => {
    try {
        if (status === false) {
            return {
                ...state,
                ...{
                    currentRole: {
                        ...state.currentRole,
                        ...{
                            action_ids: [],
                        },
                    },
                },
            }
        } else {
            let ans = []
            for (let index = 0; index < modules.length; index++) {
                let module = modules[index]
                for (let indexA = 0; indexA < module.actions.length; indexA++) {
                    let action = module.actions[indexA]
                    ans.push(action.type)
                }
            }

            return {
                ...state,
                ...{
                    currentRole: {
                        ...state.currentRole,
                        ...{
                            action_ids: ans,
                        },
                    },
                },
            }
        }
    } catch {
        return state
    }
}

const reducer = (state = initState, action) => {
    switch (action.type) {
        case actions.type.GET_CURRENT_ROLE_USER_DONE:
            return {
                ...state,
                ...{
                    currentroleOfUser: action.payload.data,
                },
            }
        case actions.type.LOAD_LIST_ROLE:
            return state

        case actions.type.LOAD_LIST_ROLE_SUCCESS:
            return {
                ...state,
                ...{
                    roles: action.payload.roles,
                },
            }

        case actions.type.SET_DEFAULT_CURRENT_ROLE:
            return {
                ...state,
                ...{
                    currentRole: defaultRole,
                },
            }

        case actions.type.UPDATE_CURRENT_ROLE:
            return {
                ...state,
                ...{
                    currentRole: {
                        ...state.currentRole,
                        ...action.payload.role,
                    },
                },
            }

        case actions.type.SAVE_CURRENT_ROLE:
            return state

        case actions.type.DELETE_ROLE:
            return state

        case actions.type.UPDATE_STATE:
            return {
                ...state,
                ...action.payload.state,
            }

        case actions.type.CHANGE_PAGE_SIZE:
            return {
                ...state,
                ...{
                    pageSize: action.payload.pageSize,
                },
            }

        case actions.type.CHANGE_CURRENT_PAGE:
            return {
                ...state,
                ...{
                    pageIndex: action.payload.pageIndex,
                },
            }

        case actions.type.SHOW_MODAL_CURRENT_ROLE_INFO:
            return {
                ...state,
                ...{
                    modalRoleInfoState: true,
                },
            }

        case actions.type.DISMISS_MODAL_CURRENT_ROLE_INFO:
            return {
                ...state,
                ...{
                    modalRoleInfoState: false,
                },
            }

        case actions.type.SHOW_MODAL_CONFIRM_DELETE_ROLE:
            return {
                ...state,
                ...{
                    modalConfirmDeleteRole: true,
                },
            }

        case actions.type.DISMISS_MODAL_CONFIRM_DELETE_ROLE:
            return {
                ...state,
                ...{
                    modalConfirmDeleteRole: false,
                },
            }

        case actions.type.UPDATE_ACTION:
            return _handleUpdateAction(
                state,
                action.payload.actionId,
                action.payload.status
            )

        case actions.type.UPDATE_ALL_ACTION:
            return _handleUpdateAllAction(state, action.payload.status)

        default:
            return state
    }
}

export default reducer
